import { render, staticRenderFns } from "./productSlider.vue?vue&type=template&id=6b87a3c7"
import script from "./productSlider.vue?vue&type=script&lang=js"
export * from "./productSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Slider: require('/vercel/path0/components/ui/slider.vue').default})
